// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Notice-module__logo-H4yjN {
  align-self: center;
  padding: 16px;
}

.nightbot-Notice-module__panel-wdRL9 {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  padding: 0px;
  width: 100%;
  align-items: center;
}

.nightbot-Notice-module__divider-YOT8V {
  width: 100%;
}

.nightbot-Notice-module__buttons-BAfBe {
  padding: 16px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 16px;
  border-top-width: 1px;
  border-color: var(--border-primary);
}

.nightbot-Notice-module__buttons-BAfBe  > * {
    flex: 1;
  }

.nightbot-Notice-module__afterElement-GfkBS {
  width: 100%;
  padding: 0px 16px;
  margin-bottom: 16px;
}

.nightbot-Notice-module__header-lzg6g {
  text-align: center;
  padding: 16px;
  width: 100%;
}

.nightbot-Notice-module__beforeElement-zyQhW {
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Notice.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,mCAAmC;AAKrC;;AAHE;IACE,OAAO;EACT;;AAGF;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".logo {\n  align-self: center;\n  padding: 16px;\n}\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  max-width: 400px;\n  padding: 0px;\n  width: 100%;\n  align-items: center;\n}\n\n.divider {\n  width: 100%;\n}\n\n.buttons {\n  padding: 16px;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  gap: 16px;\n  border-top-width: 1px;\n  border-color: var(--border-primary);\n\n  > * {\n    flex: 1;\n  }\n}\n\n.afterElement {\n  width: 100%;\n  padding: 0px 16px;\n  margin-bottom: 16px;\n}\n\n.header {\n  text-align: center;\n  padding: 16px;\n  width: 100%;\n}\n\n.beforeElement {\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `nightbot-Notice-module__logo-H4yjN`,
	"panel": `nightbot-Notice-module__panel-wdRL9`,
	"divider": `nightbot-Notice-module__divider-YOT8V`,
	"buttons": `nightbot-Notice-module__buttons-BAfBe`,
	"afterElement": `nightbot-Notice-module__afterElement-GfkBS`,
	"header": `nightbot-Notice-module__header-lzg6g`,
	"beforeElement": `nightbot-Notice-module__beforeElement-zyQhW`
};
export default ___CSS_LOADER_EXPORT___;
